
jQuery(function($){

	if( $('#tour-video-lightbox').length ) {


		// When video lightbox triggers are clicked, add the 'autoplay' param to the video url
		$("[data-lightbox='#tour-video-lightbox']").on('click', function(event) {

			// Find the first (active) video inside the lightbox and play it when the lightbox opens by appending the autoplay parameter
			$($(this).data('lightbox')).find(".tour-video.js-active").attr('src', $('.tour-video.js-active').attr('src') + '&autoplay=1');

			// const videoSrc = $($(this).data('lightbox')).find(".tour-video").attr('src');
			// const paramsString = videoSrc.split("?")[1];
			// const urlParams = new URLSearchParams(paramsString);
			// var autoPlayVal = urlParams.get('autoplay'); //extract the autoplay parameter - this will return NULL if autoplay isn't a parameter
			// if(!autoPlayVal) { //check if autoplay parameter is set to anything
			// 	$($(this).data('lightbox')).find(".tour-video").attr('src', $('.tour-video').attr('src') + '&autoplay=1');
			// }
			
		});


		// When the close button or background overlay is clicked, remove the 'autoplay' param from the video urls
		$(".custom-lightbox__overlay, .custom-lightbox__close").on('click', function(event) {
			stopAllVideos();
		});


		// When the ESC key is pressed, remove the 'autoplay' param from the video urls
		$(document).on('keydown', function(event) {
			if (event.key == "Escape") {
				stopAllVideos();
			}
		});


		function stopAllVideos() {

			// Find all the tour videos
			var videoElements = $('#tour-video-lightbox').find(".tour-video");

			// Remove the autoplay param from all of them
			videoElements.each(function(index, element) {
				var videoSrc = $(this).attr('src');
				var regex = new RegExp("&autoplay=\\d+");
				videoSrc = videoSrc.replace(regex, '');
				$(this).attr("src",videoSrc);
			});

		}


		//
		// Menu / Switching between videos
		//

		$(document).on('click', '.tour-videos--menu button:not(.js-active)', function() {

			// Make clicked button active
			$(".tour-videos--menu button").removeClass("js-active");
			$(this).addClass("js-active");

			// Stop playing all the videos
			stopAllVideos();

			// Get the right one
			var targetVideoElement = $(".tour-video[data-index='" + $(this).data("index") + "']");

			// Play the right one
			targetVideoElement.attr('src', targetVideoElement.attr('src') + '&autoplay=1');
			
			// Hide all videos, then show the right one
			$(".tour-video").removeClass("js-active");
			targetVideoElement.addClass("js-active");


		});


	}

});







